[
 {
  "id": "panel",
  "x": 61,
  "y": 381,
  "w": 821,
  "h": 919
 }
]